<template>
    <q-dialog v-model="showDialog" @hide="$emit('close')">
        <q-card class="links-asset-card text-white" id="linkedAssetDialog">
            <q-bar class="bg-primary top-bar" color="white">
                <div>{{ $t('Linked Assets') }}</div>
                <q-space />
                <q-btn @click="$emit('close')" dense flat icon="close">
                    <q-tooltip>{{ $t('Close') }}</q-tooltip>
                </q-btn>
            </q-bar>
            <q-card-section>
                <div class="row items-center text-black">
                    <span class="text-h6 text-weight-medium">{{
                        serialNumber
                    }}</span>
                </div>
                <div class="row q-mb-md text-grey-8">
                    <span class="text-weight-medium">{{ facilityName }}</span>
                </div>
                <device-linked-assets-table
                    :assets="assets"
                    :facilityId="facilityId"
                />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn
                    class="q-mx-md q-mb-sm"
                    outline
                    :label="$t('Close')"
                    color="primary"
                    @click="$emit('close')"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import DeviceLinkedAssetsTable from './DeviceLinkedAssetsTable.vue';
import { mapState } from 'pinia';
import { useFacilitiesStore } from '@stores/facilities.ts';

export default {
    name: 'DeviceLinkedAssets',
    components: { DeviceLinkedAssetsTable },
    emits: ['close'],
    props: {
        facilityId: {
            type: [Number, String],
            required: true
        },
        assets: {
            type: Array,
            required: true,
            validator(propValue) {
                // Check if props is an array
                if (!Array.isArray(propValue)) {
                    return false;
                }

                // Check if item is an object
                function validateItemObject(item) {
                    return typeof item === 'object';
                }

                // Check if item has properties
                function validateItemProperties(item) {
                    return (
                        Object.hasOwn(item, 'id') ||
                        Object.hasOwn(item, 'name') ||
                        Object.hasOwn(item, 'uuid')
                    );
                }

                // Check if item properties has the right types
                function validateItemPropertiesTypes(item) {
                    return (
                        typeof item.id === 'number' ||
                        typeof item.name === 'string' ||
                        typeof item.uuid === 'string'
                    );
                }

                // Check each object inside the array
                for (const el of propValue) {
                    if (!validateItemObject(el)) {
                        return false;
                    }
                    if (!validateItemProperties(el)) {
                        return false;
                    }
                    if (!validateItemPropertiesTypes(el)) {
                        return false;
                    }
                }
                return true;
            }
        },
        show: {
            type: Boolean,
            required: true
        },
        serialNumber: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState(useFacilitiesStore, ['getFacility']),
        /**
         * Get facility name
         * @returns {string}
         */
        facilityName() {
            if (this.getFacility(this.facilityId)) {
                return this.getFacility(this.facilityId).name;
            }
            return null;
        }
    },
    watch: {
        /**
         * Controls dialog visibility
         */
        show: {
            immediate: true,
            handler(val) {
                this.showDialog = val;
            }
        }
    },
    data() {
        return {
            isLoading: false,

            dateTimePicker: {
                start: null,
                end: null
            },
            showDialog: false
        };
    }
};
</script>
<style lang="scss" scoped>
.links-asset-card {
    width: 100%;
    max-width: 400px;
}
</style>
